import * as ents from '@attain-apps/entities'
import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import * as transformers from '@attain-apps/transformers'

export const TRANSFORMER = transformers.combine(
  graphql.transformers.OUT.enumeration<
    graphql.schema.ScenarioVisibility,
    ents.core.admin.Scenario.Visibility
  >({
    [graphql.schema.ScenarioVisibility.Hidden]:
      ents.core.admin.Scenario.Visibility.Hidden,
    [graphql.schema.ScenarioVisibility.Pinned]:
      ents.core.admin.Scenario.Visibility.Pinned,
    [graphql.schema.ScenarioVisibility.Visible]:
      ents.core.admin.Scenario.Visibility.Visible,
  }),
  graphql.transformers.IN.enumeration<
    ents.core.admin.Scenario.Visibility,
    graphql.schema.ScenarioVisibility
  >({
    [ents.core.admin.Scenario.Visibility.Hidden]:
      graphql.schema.ScenarioVisibility.Hidden,
    [ents.core.admin.Scenario.Visibility.Pinned]:
      graphql.schema.ScenarioVisibility.Pinned,
    [ents.core.admin.Scenario.Visibility.Visible]:
      graphql.schema.ScenarioVisibility.Visible,
  }),
)
